<template>
  <div class="bg-white d-flex align-content-center align-items-center justify-content-between text-uppercase py-3 px-4">
    <div class="d-flex align-content-center align-items-center px-2">
      <CIcon class="mr-2 text-black-50 font-weight-lighter" size="custom-size" :name="channel" :height="30" viewBox="0 0 32 32" />
      <h5 class="text-secondary font-weight-normal">
        {{ $t(`general.channels.${channel}`) }}
      </h5>
    </div>

    <!-- <div class="px-2 py-1">
      <ToogleSwitch :stateSwith="stateSwith" @toggle-swicthe="toggleSwicthe" />
    </div> -->
  </div>
</template>

<script>
import ToogleSwitch from '@/components/ToogleSwitch'

export default {
  name: 'ToogleChannel',
  components: {
    // ToogleSwitch,
  },
  props: {
    channel: {
      type: String,
      required: true,
    },
    stateSwith: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    toggleSwicthe(state) {
      this.$store.commit('backOffice/TOGGLE_SWITCH_CHANNEL', { state, channel: this.channel })
    },
  },
}
</script>
